export function getSlides (prjs, isPortrait) {
  // Function that returns an array of all Projects' Slides
  // include Project ID, Type, Format
  const slides = []
  const clone = obj => JSON.parse(JSON.stringify(obj))
  // loop prjs
  prjs.forEach(prj => {
    let counter = 0
    // loop slices
    prj.body.forEach(slice => {
      // setup
      const format = isPortrait ? 'single' : slice.primary.format
      const slide = {
        id: prj.id,
        format: format,
        images: [],
        urls: [],
        hmnIndex: -1
      }
      // Single Image Slides
      if (slice.slice_type === 'image') {
        slide.images.push(slice.primary.image)
        slide.urls.push(slice.primary.image.url)
        counter++
        slide.hmnIndex = counter
        slides.push(slide) // push whole slide
      // Diptych / Two-Up Slides
      } else {
        if (isPortrait) {
          // Portrait - break into single slides
          slice.items.forEach((item, ii) => {
            if (ii > 1) return
            const _slide = clone(slide) // need to clone otherwise funky stuff happens
            _slide.images = [item.image]
            _slide.urls = [item.image.url]
            counter++
            _slide.hmnIndex = counter
            slides.push(_slide) // push each item
          })
        } else {
          // Desktop
          slide.urls = slice.items.map(item => item.image.url)
          slide.images = slice.items.map(item => item.image)
          slide.hmnIndex = `${counter + 1}–${counter + 2}`
          counter = counter + 2
          slides.push(slide) // push whole slide
        }
      }
    })
  })
  return slides
}

export function getSlidesImages (prjs) {
  // "functional programming" approach – all pure ƒ, no mutations !
  const collect = (arr, callback) => arr.reduce(callback, [])
  const addId = (items, id) => items.map(item => { return {id: id, ...item} })
  const isSingle = slice => slice.slice_type === 'image' && slice.primary.image
  const getDiptychImgs = dips => collect(dips, (acc, dip) => [...acc, {url: dip.image.url}])
  const getSlicesImgs = slices => collect(slices, (results, slice) => {
    let imgs = []
    if (isSingle(slice)) imgs.push({url: slice.primary.image.url})
    else imgs = getDiptychImgs(slice.items)
    return [...results, ...imgs]
  })
  const getAllImgs = prjs => collect(prjs, (results, prj) => {
    let imgs = getSlicesImgs(prj.body)
    imgs = addId(imgs, prj.id)
    return [...results, ...imgs]
  })
  return getAllImgs(prjs)
}



// WEBPACK FOOTER //
// ./src/components/helpers/slideUtils.js